import {RootState} from '../../../store';

export const getIsPropertyProtectionPaymentPreloaded = (state: RootState) =>
  state.payments.isPropertyProtectionPaymentPreloaded;
